import apiServices from "../services/service";
import { decodeJwt } from "./jwtUtils";

const ACCESS_TOKEN_KEY = "accessToken";
const REFRESH_TOKEN_KEY = "refreshToken";
const LOGIN_TYPE_KEY = "loginType";
let refreshTimeout = null;
const isTokenExpiringSoon = (token) => {
    if (!token) return true;
    const decoded = decodeJwt(token);
    if (!decoded?.exp) return true;
    const expiry = decoded.exp * 1000;
    const now = Date.now();
    return expiry - now < 60000; // refresh 1 min before expiry
};

const scheduleRefresh = (accessToken) => {
    const decoded = decodeJwt(accessToken);
    if (!decoded?.exp) return;
    const expiryTime = decoded.exp * 1000;
    const refreshTime = expiryTime - Date.now() - 60000;
    if (refreshTimeout) clearTimeout(refreshTimeout);
    if (refreshTime > 0) {
        refreshTimeout = setTimeout(() => {
            refreshTokenSilently();
        }, refreshTime);
    }
};

const refreshTokenSilently = async () => {
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY);
    if (!refreshToken) return;
    try {
        const response = await apiServices.refreshToken({ refreshToken });
        const { accessToken, refreshToken: newRefreshToken } = response.data;
        tokenManager.setTokens(accessToken, newRefreshToken);
    } catch (error) {
        tokenManager.clearAll();
        window.location.replace("/login");
    }
};

export const tokenManager = {

    initialize() {
        const token = this.getAccessToken();
        const loginType = this.getLoginType();
        if (token && loginType === "db") {
            scheduleRefresh(token);
        }
    },

    setTokens(accessToken, refreshToken) {
        if (accessToken) {
            localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
            scheduleRefresh(accessToken);
        }
        if (refreshToken) {
            localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
        }
    },

    getAccessToken() {
        return localStorage.getItem(ACCESS_TOKEN_KEY);
    },

    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    },

    getLoginType() {
        return localStorage.getItem(LOGIN_TYPE_KEY);
    },

    setLoginType(type) {
        localStorage.setItem(LOGIN_TYPE_KEY, type);
    },

    isTokenExpiringSoon() {
        const token = this.getAccessToken();
        return isTokenExpiringSoon(token);
    },

    clearAll() {
        if (refreshTimeout) clearTimeout(refreshTimeout);
        localStorage.clear();
        sessionStorage.clear();
    }

};